
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lens",
      function () {
        return require("private-next-pages/lens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lens"])
      });
    }
  